// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"80":"4f433e09","208":"5c8f710b","540":"4afd0a48","584":"a335942e"}[chunkId] + ".js";
};